import React from 'react';
import {Avatar, Col, Layout, Popover, Row, message, Icon, Modal, Select} from "antd";
import {
    changeNavigateStauts,
    getInfoFromLocalStorage,
    logout,
    postPublic,
    setInfoToLocalStorage,
    changeLoginStatus,
    loadSystemConfigList,
    loadCurrentUser,
    loadNavigateData,
    updataNavigateData,
    shrinNavigateStauts,
    updateNavigateLevel2Data, removeInfoFromLocalStorage
} from "../actions";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {
    EDITOR_DOMAIN_NAME_URL,
    HEADER_HEIGHT,
    ZYK_HOST,
    NAVIGATE_LEVEN2_WIDTH,
} from "../constants";
import {getUnreadCount} from "../actions/index";
import $ from "jquery";
import PmsNavigateLevel1 from "./pmsNavigate";
import BaseComponent ,{getModAuth} from "../base/BaseComponent";
import {applicationName, findUrlData} from "../utils";
import AmendPassword from "../components/amendPassword/AmendPassword";
import Profile from './Profile.jsx';
import {begin, systemWebsocket} from "../base/auth";
import Login from "../containers/login/index"
import processCenter from '../containers/publishRecord/images/processCenter.png'
import {systemBaseEvent} from "../base/baseEvent";
import {refreshToken} from "../base/request";
import { menuBlock } from './menuClickBlock.js';
const {Header} = Layout;
const scarpyBtnClick = "javascript:void((function(){if(!window.onKeyLoad){var t=document.createElement('script');t.id='_oneKeyReprintSheet',t.type='text/javascript',t.charset='UTF-8',t.targetUrl='" + window.location.origin + "',t.src='" + EDITOR_DOMAIN_NAME_URL + "/static/demo.js',t.onerror=function(){alert('不能访问到服务器" + EDITOR_DOMAIN_NAME_URL + "/')},t.onload=function(){},document.getElementsByTagName('HEAD')[0].appendChild(t)}else{window.onKeyLoad()}})());";
const zykBtnClick = "javascript:void((function(){if(!window.onKeyLoad){var t=document.createElement('script');t.id='_oneKeyReprintSheetZyk',t.type='text/javascript',t.charset='UTF-8',t.src='" + ZYK_HOST + "/static/demo.js',t.onerror=function(){alert('不能访问到服务器" + ZYK_HOST + "')},t.onload=function(){},document.getElementsByTagName('HEAD')[0].appendChild(t)}else{window.onKeyLoad()}})());";
const {Option} = Select;

const {confirm} = Modal;

class CmsitesHeader extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            messageCount: 0,
            projectTitle_cn: '',
            profileVisible: false,
            deptList: [],// 切换部门数据
            thisDept: [],
            userId: "",
            deptValue:"",
            userInfoList:{},
            defaultDeptValue:{},
            messageStatus: false,
            popoverVisible: false
        }
         window.menuBlock = menuBlock;
    }

    componentWillMount() {
    }
    componentWillUnmount() {
        // 销毁路由监听
        menuBlock.destroy();
        clearInterval(this.timeId);
    }
    getDept = (call) => {
        this.request({
            url: '/cm-sites-sys/user/getCurrentUser',
            callBack: (res) => {
                let userInfoList = {};
                if (res) {
                    userInfoList = res;
                    // 修改头像
                    let storedData = getInfoFromLocalStorage('currentUser');
                    if (userInfoList && userInfoList.photoUrl) {
                        storedData.photoUrl = userInfoList.photoUrl;
                        setInfoToLocalStorage("currentUser", storedData);
                    }
                    call && call(res);
                }
                this.setState({userInfoList},()=>{
                    let infoList=this.state.userInfoList.infoList;
                    let deptList = [];
                    infoList.forEach(item=>{
                        if(item.dept){
                            deptList.push(item.dept)
                        }
                    });
                    this.setState({
                        defaultDeptValue:this.state.userInfoList.defaultInfo,
                        userId : this.state.userInfoList.id,
                        deptList,
                    })
                });
            }
        })
    };
    componentDidMount() {
        this.messageDataSource();
        $('#collection').attr("href", scarpyBtnClick);
        $("#zykBtn").attr("href", zykBtnClick);
        /*if(applicationName() !== "sys"){
            getUnreadCount({},(data)=>{
                if(data.status===200){
                    this.setState({
                        messageCount:data.data.count
                    })
                }
            });
        }*/
        // this.setState({
        //     deptList:this.props.currentUser.deptList
        // })

        // console.log("this.props.currentUser",this.props.currentUser)
        let {config} = this.getInfo();
        //获取标题中文名称，
        if (config) {
            let projectTitleConfig = config.getConfigByKey("contribute.project.title");
            if (projectTitleConfig && projectTitleConfig.configValue) {
                let projectTitle_cn = projectTitleConfig.configValue;
                this.setState({
                    projectTitle_cn: projectTitle_cn,
                });
                $("#index_title").text(projectTitle_cn);
            }
        }
        window.addEventListener('resize', this.resize.bind(this));

        //初始密码验证
        if (applicationName() !== "sys") {
            window.initializationPassword()
        }

        //利用缓存判断是否弹出修改密码框
        let params = getInfoFromLocalStorage("loginPassword")
        if (params && params.status && params.isFirst) {
            //调用修改密码
            window.editPassword();
            params.isFirst = false;
            setInfoToLocalStorage("loginPassword", params)
        }
        // console.log(this.state.deptValue)


        //处理菜单 回退前进的问题
        let currentUrl=window.top.location.hash;
        currentUrl=currentUrl.replace('#','');
        let {stopFind, sons, name} = this.findUrlData(currentUrl);
       if (stopFind) {
             this.props.shrinNavigateStauts();
             this.props.updateNavigateLevel2Data(name, sons);
             this.props.navigateData.forEach(item => {
                 if (item.menuName === name) {
                     item.check = true;
                     item.status = "down"
                 } else {
                     item.check = false;
                     item.status = "up"
                 }
             });
             this.props.updataNavigateData(this.props.navigateData);

         }
        // 获取切换部门数据
        // let defaultDeptInfo = getInfoFromLocalStorage("currentUser");
        let deptList = [];
        this.getDept((defaultDeptInfo)=>{
            this.state.defaultDeptValue = defaultDeptInfo.defaultInfo || {};
            this.state.userId = defaultDeptInfo.id || '';
            defaultDeptInfo.infoList && defaultDeptInfo.infoList.forEach(item => {
                if (item.dept) {
                    deptList.push(item.dept)
                }
            });
        });
        this.state.deptList = deptList;
        this.setState({});
        let that = this;
        systemBaseEvent.registerBaseEvent("changeDept", ()=>{
            // 有人切换了部门，请求刷新token和用户信息
            refreshToken((data)=>{
                if(data) {
                    let deptData = data;
                    that.getMediaPort(()=>{
                        that.systemInit(deptData);
                    });
                }
            });
        });
    }

    resize() {
        this.setState({})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            messageCount: nextProps.messageCount,
        })
    }

    showConfirm() {
        confirm({
            title: "确认要退出吗 ?",
            zIndex:999999999,
            onOk: () => {
                setTimeout(function () {
                    logout("", false, () => {
                        systemWebsocket.close();
                        sessionStorage.clear();
                       // this.props.changeLoginStatus({ status: "false" });
                       window.location.reload();
                    });
                },100)
            }
        });
    }

    editPassword() {
        this.AmendPassword.show()
        this.handleContentClick()
    }

    showProfily = () => {
        this.setState({
            profileVisible: true
        }, () => {
            this.handleContentClick()
        })
    };
    hideProfile = () => {
        this.setState({
            profileVisible: false
        })
    };
    handlePopoverVisibleChange = (visible) => {
        this.setState({ popoverVisible: visible });
    };

    handleContentClick = () => {
        this.setState({ popoverVisible: false });
    };

    render() {
        const {profileVisible, deptList, popoverVisible} = this.state;
        let {config} = this.getInfo();
        const content = (
            <div>
                <div style={{cursor: "pointer", marginBottom: 0, width: '100%', marginRight: '50px'}}
                   className={'personalCenter'} onClick={() => this.showProfily()}>个人信息</div>

                <div style={{cursor: "pointer", marginBottom: 0, width: '100%', marginRight: '50px'}}
                   className={'personalCenter'} onClick={() => this.editPassword()}>修改密码</div>
                <style>{`
                    .personalCenter{
                        padding:10px 15px;
                    }
                    .personalCenter:hover{
                        background:rgba(0, 80, 179, 0.04);
                    }
                `}</style>
                <p style={{
                    cursor: "pointer",
                    marginBottom: 0,
                    borderTop: '1px solid #e8e8e8',
                    color: '#F56C6C',
                    textAlign: 'center'
                }} className={'personalCenter'} onClick={() => {
                    this.showConfirm()
                    this.handleContentClick()
                }}>退出登录</p>
            </div>
        );

        let defaultColor = config && config.getValueByKey ? config.getValueByKey("NewMenuDefaultColor", 'white') : 'white';
        let newSecondSelectColor = config && config.getValueByKey ? config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let oneAcquisitionShow = config && config.getValueByKey ? config.getValueByKey("pms.oneAcquisition", '0') : '0';
        if (oneAcquisitionShow === '1') {
            oneAcquisitionShow = true
        } else {
            oneAcquisitionShow = false;
        }

        let sex = null;
        if (this.props.currentUser){
            sex = this.props.currentUser.sex;
        }
        let photo = "images/header_boys.png";
        if (this.props.currentUser && this.props.currentUser.photoUrl && this.props.currentUser.photoUrl.length > 0) {
            photo = this.props.currentUser.photoUrl
        } else {
            if (sex === 2) {
                photo = "images/header_girls.png";
            }
        }
        let currentUser=getInfoFromLocalStorage("currentUser");
        // let name = (currentUser ? currentUser.name : "") + '，欢迎您！';
        let name = (currentUser ? currentUser.name : "");
        if (name && name.length > 5) {
            name = name.slice(0, 5) + '...'
        }
        // if(currentUser&&currentUser.photoUrl){
        //     photo=currentUser.photoUrl;
        // }
        if (this.state.userInfoList && this.state.userInfoList.photoUrl && this.state.userInfoList.photoUrl.length > 0) {
            photo = this.state.userInfoList.photoUrl
        }

        let rightArea = (
            <Col style={{height: "70px", color: defaultColor}}>
                <Avatar src={photo} style={{marginRight: "10px"}} size={35}/>
                <span style={{marginRight: "35px", height: HEADER_HEIGHT + "px", lineHeight: HEADER_HEIGHT + "px"}}>
                    超级管理员，欢迎您！
                </span>
                {/*<Icon type="logout" style={{fontSize: 16, color: defaultColor}} onClick={() => {*/}
                {/*    this.showConfirm()*/}
                {/*}}/>*/}
            </Col>);

        if (applicationName() !== "sys") {
            // console.log('this.state.userInfoList.defaultInfo-----------',this.state.defaultDeptValue);
            // let defaultValue = this.state.userInfoList.defaultInfo.dept.name;
            if(this.state.deptList.length > 1){
                let deptName=this.state.defaultDeptValue.dept.name;
                // if(deptName.length>5){
                //     this.state.deptName=deptName.substr(0,5)+'...'
                // }else{
                    this.state.deptName=deptName;
                // }
                $('.header .ant-select-selection-selected-value').removeAttr('title').attr('title',this.state.defaultDeptValue.dept.name);
            }
            rightArea = (
                <Col style={{height: "70px", color: defaultColor}} className={'header'}>
                    {
                        this.state.deptList.length > 1 ?
                            <span>
                                <Select
                                    suffixIcon={
                                        <div>
                                            <Icon type={"swap"}/>
                                            <span style={{
                                                // width: 10,
                                                // height: 32,
                                                borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                                verticalAlign: 'top',
                                                marginLeft: 16
                                            }}/>
                                        </div>
                                    }
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    value={this.state.deptName}
                                    // defaultOpen={true}
                                    style={{width: 155, marginRight: 10, fontSize: 16}}
                                    dropdownClassName={'dropdownDept'}
                                    // dropdownStyle={{marginTop:'50px'}}
                                    onSelect={(e, option) => {
                                        this.changeDept(option.key);
                                        // this.reloadUserMenu();
                                        // this.setState({deptName:option.key})
                                    }}>
                                    {
                                        deptList.map(item => {
                                            // console.log(item);
                                            // if(this.state.deptId===item.id){
                                            //     this.setState({deptName:item.name})
                                            // }
                                            return (
                                                <Option value={item.name} key={item.id}>{item.name}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </span>
                            : null
                    }
                    <style>
                        {`
                            .header .ant-select-selection{
                              border:none;
                              background-color:transparent !important;
                            }
                            .header .ant-select{
                              color:#fff;
                            }
                            .header .ant-select-selection-selected-value{
                              padding-right:5px;
                            }
                            .header .ant-select-arrow svg{
                              font-size:16px;
                              margin-top:-2px;
                              color:#fff;
                            }
                           .header .ant-select-dropdown{
                            top: 70px !important;
                            }
                            .header .ant-select-selection__rendered{
                            display: flex;
                            justify-content: end;
                            padding-right:20px;
                            }
                            .header .ant-select-dropdown-menu{
                            text-align: start;
                            }
                            .header .ant-select-dropdown-menu-item-selected {
                            background-color:#e7ecf1 !important;
                            color:rgba(0, 0, 0, 0.65) !important;
                            }
                            .header .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
                            background-color:#e7ecf1 !important;
                            color:rgba(0, 0, 0, 0.65) !important;
                            }
                            .header .ant-select-dropdown-menu-item-active {
                            background-color: #e7ecf1 !important;
                            color: rgba(0, 0, 0, 0.65) !important;
                            }
                            .header .ant-popover-arrow{
                            display:none;
                            }
                        `}
                    </style>
                    {/* <Link to={"/view/sysManagement/processCenterUntreated"} onClick={() => {
                        this.setState({messageCount: 0})
                    }} style={{color: defaultColor}}>
                        <img style={{width: 20, height: 20, marginRight: 15, verticalAlign: "sub"}}
                             src={processCenter}/>
                    </Link> */}
                    {/* <span style={{
                        marginRight: "22px",
                        height: HEADER_HEIGHT + "px",
                        lineHeight: HEADER_HEIGHT + "px",
                        position: 'relative'
                    }}>
                        <Link to={"/view/sysManagement/messageCenter"} onClick={() => {
                            this.setState({messageCount: 0})
                        }} style={{color: defaultColor}}>
                            <Icon style={{fontSize: '20px', verticalAlign: "sub"}} type="bell"/>
                    
                        </Link>
                        {
                            this.state.messageStatus ?
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: 'red'
                                }}/> : null
                        }
                    </span> */}

                    <Popover title={""} placement="bottom" content={content} trigger="hover"
                             visible={popoverVisible}
                             onVisibleChange={this.handlePopoverVisibleChange}
                             getPopupContainer={triggerNode => triggerNode.parentNode}>
                        <Avatar src={photo} style={{marginRight: "10px"}} size={35}/>
                        <span title={(this.props.currentUser ? this.props.currentUser.name : "") + '欢迎您！'} style={{
                            marginRight: "15px",
                            height: HEADER_HEIGHT + "px",
                            lineHeight: HEADER_HEIGHT + "px",
                            
                        }}>
                            <span>
                                {name}
                                <Icon type="caret-down" style={{color: '#3070c1', marginLeft: 10}}/>
                                {/*{this.state.isUp ? <Icon type="caret-up" style={{color: '#3070c1', marginLeft: 10}}/> :*/}
                                {/*    <Icon type="caret-down" style={{color: '#3070c1', marginLeft: 10}}/>}*/}
                            </span>

                            {/*{this.props.currentUser?this.props.currentUser.name:""}，欢迎您！*/}
                        </span>
                    </Popover>
                    <style>
                        {`
                        .header .ant-popover-inner-content{
                            padding:0px;
                        }
                        .header .ant-popover-placement-bottom{
                            padding-top:21px;
                        }
                        .header .ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow, .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow{
                            top:17px;
                        }
                        .header .ant-select-selection-selected-value{
                            width:100px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow:ellipsis;
                        }
                        `}
                    </style>
                    {/* <img alt={"消息通知"} src={"images/noticenone.png"} style={{marginTop:"-6px"}} />*/}
                    {/*<Icon type="bell" style={{fontSize: 15, color: newSecondSelectColor}}/>*/}
                    {this.state.messageCount > 0 ? <div style={{
                        width: 10,
                        height: 10,
                        background: 'red',
                        display: 'inline-block',
                        borderRadius: '50%',
                        marginLeft: '-11px',
                        marginBottom: '6px'
                    }}/> : null}
                    {oneAcquisitionShow && applicationName() === "pms" ?
                        <span style={{
                            marginRight: "35px",
                            height: HEADER_HEIGHT + "px",
                            lineHeight: HEADER_HEIGHT + "px"
                        }}>
                        <a id={'collection'} href='#!'
                           onClick={() => {
                               message.info("请将此按钮拖到浏览器书签栏或右键添加到收藏夹。");
                               window.event.preventDefault();
                           }}
                           className={"ant-btn ant-btn-dashed"}>一键采集</a>
                    </span> : ""}
                    {/*{applicationName()==="pms"?*/}
                    {/*<span style={{marginRight:"35px",height: HEADER_HEIGHT + "px",lineHeight: HEADER_HEIGHT + "px"}}>*/}
                    {/*    <a id={'zykBtn'} href='#!'*/}
                    {/*       onClick={()=>{message.info("请将此按钮拖到浏览器书签栏或右键添加到收藏夹。");window.event.preventDefault();}}*/}
                    {/*       className={"ant-btn ant-btn-dashed"}>媒资库</a>*/}
                    {/*</span>:""}*/}
                    {/*<span>*/}
                    {/*   <Icon type="logout" style={{fontSize: 16, color: defaultColor}} onClick={() => {*/}
                    {/*       this.showConfirm()*/}
                    {/*   }}/>*/}
                    {/*</span>*/}
                </Col>);
        }

        // let imgWidth = 100;//parseInt(NAVIGATE_LEVEN2_WIDTH) + 30;
        let titleWidth = config && config.getValueByKey ? config.getValueByKey("comm.web.header.title.width", '250') : '250';
        titleWidth = parseInt(titleWidth);
        let titleFontSize = config && config.getValueByKey ? config.getValueByKey("comm.web.header.title.fontSize", '24') : '24';
        titleFontSize = parseInt(titleFontSize);
        let titleColor = config && config.getValueByKey ? config.getValueByKey("comm.web.header.title.color", '#fff') : '#fff';
        let logoImg = config && config.getValueByKey ? config.getValueByKey("sys.logo", 'images/topLeftLogo.png') : 'images/topLeftLogo.png';
        let imgLeftWidth = config && config.getValueByKey ? config.getValueByKey("sys.logoLeft.width", '80') : '80';
        let logoImgWidth = config && config.getValueByKey ? config.getValueByKey("sys.logo.width", '48') : '48';
      
        let logoImgHeight = config && config.getValueByKey ? config.getValueByKey("sys.logo.height", '48') : '48';
        let projectName = this.state.projectTitle_cn ? this.state.projectTitle_cn : process.env.REACT_APP_CNAME;
        let rightWidth = 410;
        switch (this.props.isNewMenu) {
            case '0':
                return (
                    <Header style={{
                        background: "#0050B3",
                        height: "64px",
                        paddingLeft: "0px",
                        paddingRight: "20px",
                        fontSize: "14px",
                        color: "#000"
                    }}>
                        <Row type="flex" justify="space-between" align="middle" style={{height: "70px"}}>
                            <Col style={{height: "70px", lineHeight: "70px", cursor: "pointer"}}>
                                <img alt={"导航状态切换"} width={70} height={70}
                                     style={{marginRight: "12px", marginTop: "-3px"}}
                                     src={"images/" + (this.props.navigateStatus ? "toleft" : "toright") + ".jpg"}
                                     onClick={this.props.changeNavigateStauts}/>
                                欢迎使用{this.state.projectTitle_cn ? this.state.projectTitle_cn : process.env.REACT_APP_CNAME}
                            </Col>
                            {rightArea}
                        </Row>
                        <Profile visible={profileVisible} onCancel={this.hideProfile}/>
                    </Header>
                );
                break;
            case '1':
                return (
                    <Header style={{
                        background: this.props.bgColor ? this.props.bgColor : 'Header',
                        height: "70px",
                        paddingLeft: "0px",
                        paddingRight: "20px",
                        fontSize: "14px",
                        color: "#000"
                    }}>
                        <div style={{display: 'flex'}}>
                            <div style={{width: imgLeftWidth + 'px', textAlign: 'right', marginRight: 20}} >
                                <img style={{width: logoImgWidth + "px", height: logoImgHeight + "px"}}
                                     src={logoImg}
                                     alt="" onClick={() => this.reloadUserMenu()}/>
                            </div>
                            <div style={{
                                width: titleWidth + "px",
                                fontSize: titleFontSize,
                                height: "68px",
                                lineHeight: "68px",
                                letterSpacing: 3,
                                fontWeight: "bold",
                                color: titleColor,
                                display: titleWidth ? 'block' : 'none'
                            }}>
                                <span>{projectName}</span>
                            </div>
                            <div id="header-nav" style={{flex: 1, margin: "0 20px"}}>
                                <PmsNavigateLevel1 position={"top"}/>
                            </div>
                            <div style={{width: rightWidth, textAlign: 'end'}}> {rightArea}</div>
                        </div>
                        <AmendPassword ref={(AmendPassword) => this.AmendPassword = AmendPassword}></AmendPassword>
                        <Profile visible={profileVisible} onCancel={this.hideProfile}/>

                    </Header>
                );
                break;
            default:
                return (
                    <Header style={{
                        background: "#FFF",
                        height: "70px",
                        paddingLeft: "0px",
                        paddingRight: "20px",
                        fontSize: "14px",
                        color: "#000"
                    }}>
                        <Row type="flex" justify="space-between" align="middle" style={{height: "70px"}}>
                            <Col style={{height: "70px", lineHeight: "70px"}}>
                                <img alt={"导航状态切换"} width={70} height={70}
                                     style={{marginRight: "12px", marginTop: "-3px"}}
                                     src={"images/" + (this.props.navigateStatus ? "toleft" : "toright") + ".jpg"}
                                     onClick={this.props.changeNavigateStauts}/>
                                欢迎使用{this.state.projectTitle_cn ? this.state.projectTitle_cn : process.env.REACT_APP_CNAME}
                            </Col>
                            {rightArea}
                        </Row>
                        <Profile visible={profileVisible} onCancel={this.hideProfile}/>
                    </Header>
                );
        }
    }

    reloadUserMenu() {
        let url = `/cm-sites-sys/menu/findUserMenuTree?clientType=0`;
        let body = {reload: true};
        let callBack = (Data) => {
            if (Data) {
                let data = Data.child;
                setInfoToLocalStorage("menu", data);
                window.location.reload();
            }
        };
        this.request({url, body, callBack});
    };
    // 消息中心数据
    messageDataSource = () => {
        let account = getInfoFromLocalStorage("currentUser").account;
        let id = getInfoFromLocalStorage("currentUser").id;
        let deptId = getInfoFromLocalStorage("currentUser").defaultInfo.dept.id;
        let params = {
            deptId: deptId,
            pageNum: 1,
            pageSize: 10,
            status: "1",
            searchInfo: "",
            userAccount: account,
            userId: id,
        };
        this.request({
            url: "/cm-sites-sys/new/notice/getList",
            body: params,
            method:'post',
            contentType:'json',
            callBack: (res) => {
                if (res) {
                    if (res.count > 0) {
                        this.setState({
                            messageStatus: true
                        });
                    }
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 切换部门
    changeDept(key) {
        // console.log("==========", this.state.deptList);
        let params = {
            loginType: 'userDept',
            deptId: key,
            id: this.state.userId,
        };
        let that = this;
        this.request({
            url: "/cm-sites-sys/v2/login",
            body: params,
            method: 'post',
            callBack: (data) => {
                // let deptData = data.data;
                // that.getMediaPort(()=>{
                //     that.systemInit(deptData);
                // });
            }
        })
    };
    getMediaPort = (callback) => {
        this.request({
            url: '/cm-sites-pms/media/getCurrentUserMediaGroupByType',
            callBack: (res) => {
                let navigationBarDate = [];
                if (res) {
                    navigationBarDate = res;
                    setInfoToLocalStorage("currentMediaList", res);
                    this.picSrc(navigationBarDate)
                }
                callback();
            },
            errorCallBack: (e) => {
            },
        })
    };
    //navigationBarDate第一层logoUrl赋值给mediaList中得mediaLogo
    picSrc = (navigationBarDate) => {
        navigationBarDate.forEach((i, index2) => {
            i.mediaList.forEach(item => {
                if (!item.mediaLogo) {
                    item.mediaLogo = i.logoUrl;
                }
            })
        });
    };
    // // 默认部门
    // getDefaultValue=()=>{
    //     this.request({
    //         url: "/cm-sites-sys/user/getCurrentUserDefaultDept",
    //         callBack: (data) => {
    //             setInfoToLocalStorage("deptDefaultValue", data.name);
    //             this.setState({})
    //         }
    //     })
    // };
    systemInit = ({accessToken, expireTime, refreshToken}) => {//正常登录之后系统初始化操作，如果登录了之后刷新页面，该方法是不会执行的,登录之后刷新会执行/route/index.js中的初始化方法
        setInfoToLocalStorage("Token", accessToken);
        setInfoToLocalStorage("expireTime", expireTime);
        setInfoToLocalStorage("refreshToken", refreshToken);
        removeInfoFromLocalStorage('bindModuleAuth');
        let isError = false;
        let changeLoginStatus = (status) => {
            if (!isError) {
                isError = status === "false" ? true : false;
                this.props.changeLoginStatus({status});
            }
            if (isError) {
                this.setState({
                    isStartLogin: false
                });
                this.changeCodeImg();
            }
        };

        let stepCount = 2;
        let loadNext = () => {
            stepCount--;
            if (stepCount === 0) {
                /*this.loadEnd();*/
                let navigateData = getInfoFromLocalStorage('menu') || [];//window.cmsitesNavigateData;
                window.location.hash = navigateData[0].path;
                removeInfoFromLocalStorage('currentMediaList');
                this.loadEnd();
                window.location.reload();
            }
        };

        this.loadStart();
        this.props.loadCurrentUser((data) => {
            let currentUser = {...data}
            if (data.defaultInfo && data.defaultInfo.dept) {
                currentUser.deptIds = [data.defaultInfo.dept.id]
                currentUser.deptList = [data.defaultInfo.dept];
                let roleList = data.defaultInfo.roleList || [];
                let roleCodes = [];
                roleList.forEach(role => {
                    roleCodes.push(role.roleCode)
                })
                currentUser.roleCodes = roleCodes;
                currentUser.roleList = roleList;
            }
            window.currentUser = currentUser;
            setInfoToLocalStorage("currentUser", currentUser);
            setInfoToLocalStorage("permissionsUserAccount", data.account);
            //设置权限
            let permissions = [];
            if (data.defaultInfo && data.defaultInfo.permissionList && data.defaultInfo.permissionList.length) {
                data.defaultInfo.permissionList.forEach(item => {
                    permissions.push(item.code)
                })
            }
            setInfoToLocalStorage("permissions", permissions);
            // console.log("用户加载完成！");
            getModAuth(()=>{
                loadNext();
            });
        }, () => {
            // console.log("用户加载失败！");
            changeLoginStatus("false");
        });
        //获取用户菜单
        let url = `/cm-sites-sys/menu/findUserMenuTree?clientType=0`;
        let body = {reload: true};
        this.request({
            url, body, callBack: (Data) => {
                if (Data) {
                    let data = Data.child;
                    setInfoToLocalStorage("menu", data);
                    //this.props.loadNavigateData();
                    loadNext();

                }
            },
            errorCallBack: () => {
                message.error("用户菜单获取失败！");
                changeLoginStatus("false");
            }
        });
    };


    //格式化url
    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.child || data.child.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.child;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.child;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.menuName);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({child: this.props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };

}

function mapStateToProps(state) {
    return {
        navigateStatus: state.systemReducer.navigateStatus,
        currentUser: state.systemReducer.currentUser,
        messageCount: state.systemReducer.messageCount,
        sysConfig: state.systemReducer.config,
        navigateData: state.systemReducer.navigateData,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        },
        loadSystemConfigList: function (callBack, errorCallBack) {
            return dispatch(loadSystemConfigList(callBack, errorCallBack));
        },
        loadCurrentUser: function (callBack, errorCallBack) {
            return dispatch(loadCurrentUser(callBack, errorCallBack));
        },
        changeLoginStatus: function (systemStatus) {
            return dispatch(changeLoginStatus(systemStatus))
        },
        loadNavigateData: function () {
            return dispatch(loadNavigateData())
        },
        updataNavigateData: function (data) {
            return dispatch(updataNavigateData(data))
        },
        changeNavigateStauts: function () {
            return dispatch(changeNavigateStauts())
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(CmsitesHeader);